import {useEffect, useState} from 'react'
import {toAbsoluteUrl} from '../../../../_metronic/helpers'
import {getContractList, getEcontractSignLinks} from './server/UpdateAccount'
import {showToast} from './middleware/showToast'
import Swal from 'sweetalert2'
import {useNavigate} from 'react-router-dom'

/* eslint-disable jsx-a11y/iframe-has-title */
export function Contract() {
  const [loading, setLoading] = useState(true)
  const [loading2, setLoading2] = useState(false)
  const [loading3, setLoading3] = useState(false)
  const [secondsRemaining, setSecondsRemaining] = useState(20)
  const [loading2Countdown, setLoading2Countdown] = useState(20)
  const [loading3Countdown, setLoading3Countdown] = useState(20)
  const [listEkycRes, setListEkycRes] = useState<any>()
  const temp = localStorage.getItem('id_no')
  const history = useNavigate()

  useEffect(() => {
    const timer = setInterval(() => {
      setSecondsRemaining((prevSeconds) => {
        if (prevSeconds === 1) {
          getContractList({idno: temp ?? null})
            .then((res: any) => {
              if (res?.error_code === '0000') {
                setListEkycRes(res)
                setLoading(false)
              } else if (res?.error_code === '1005') {
                setLoading(false)
                Swal.fire({
                  html: 'Hợp đồng chưa được khởi tạo thành công. Quý khách vui lòng nhấn Tải lại để tải hợp đồng',
                  icon: 'error',
                  showDenyButton: true,
                  denyButtonText: `Đóng`,
                  allowOutsideClick: false,
                  confirmButtonText: 'Tải lại',
                }).then((result) => {
                  if (result.isConfirmed) {
                    getEcontractSignLinks({
                      idno: temp,
                    })
                    setLoading2(true)
                    const timerId = callApiAfterDelay()

                    return () => clearTimeout(timerId)
                  } else if (result.isDenied) {
                    history('/auth')
                  }
                })
              }
            })
            .catch((err) => {
              console.log(err)
              Swal.fire({
                title: 'Liên hệ admin',
                html: `Vui lòng liên hệ NHSV theo số <b>19001055</b> để biết thêm chi tiết.`,
                allowOutsideClick: false,
                icon: 'error',
                confirmButtonText: 'Đã hiểu',
              }).then((result) => {
                if (result.isConfirmed) {
                  history('/auth')
                }
              })
              setLoading(false)
            })
          clearInterval(timer)
          return 0
        } else {
          return prevSeconds - 1
        }
      })
    }, 1000)

    return () => clearInterval(timer)
  }, [])

  const callApiAfterDelay = () => {
    const timerId = setInterval(() => {
      setLoading2Countdown((prevCountdown) => {
        if (prevCountdown === 1) {
          clearInterval(timerId)
          getContractList({idno: temp ?? null})
            .then((res: any) => {
              if (res?.error_code === '0000') {
                setListEkycRes(res)
                setLoading(false)
                setLoading2(false)
              } else if (res?.error_code === '1005') {
                setLoading2(false)
                Swal.fire({
                  html: 'Hợp đồng chưa được khởi tạo thành công. Quý khách vui lòng nhấn Tải lại để tải hợp đồng',
                  icon: 'error',
                  showDenyButton: true,
                  denyButtonText: `Đóng`,
                  allowOutsideClick: false,
                  confirmButtonText: 'Tải lại',
                }).then((result) => {
                  if (result.isConfirmed) {
                    getEcontractSignLinks({
                      idno: temp,
                    })
                    setLoading3(true)
                    const timerId = callApiAfterDelay1()

                    return () => clearTimeout(timerId)
                  } else if (result.isDenied) {
                    history('/auth')
                  }
                })
              }
            })
            .catch((err) => {
              console.log(err)
              Swal.fire({
                title: 'Liên hệ admin',
                html: `Vui lòng liên hệ NHSV theo số <b>19001055</b> để biết thêm chi tiết.`,
                allowOutsideClick: false,
                icon: 'error',
                confirmButtonText: 'Đã hiểu',
              }).then((result) => {
                if (result.isConfirmed) {
                  history('/auth')
                }
              })
            })
          return 0
        } else {
          return prevCountdown - 1
        }
      })
    }, 1000)

    return timerId
  }

  const callApiAfterDelay1 = () => {
    const timerId = setInterval(() => {
      setLoading3Countdown((prevCountdown) => {
        if (prevCountdown === 1) {
          clearInterval(timerId)
          getContractList({idno: temp ?? null})
            .then((res: any) => {
              setListEkycRes(res)
              if (res?.error_code === '0000') {
                setListEkycRes(res)
                setLoading(false)
                setLoading3(false)
              } else if (res?.error_code === '1005') {
                setLoading3(false)
                Swal.fire({
                  title: 'Hợp đồng chưa được khởi tạo thành công',
                  html: `Vui lòng liên hệ NHSV theo số <b>19001055</b> để biết thêm chi tiết.`,
                  allowOutsideClick: false,
                  icon: 'error',
                  confirmButtonText: 'Đã hiểu',
                }).then((result) => {
                  if (result.isConfirmed) {
                    history('/auth')
                  }
                })
              }
            })
            .catch((err) => {
              console.log(err)
              Swal.fire({
                title: 'Liên hệ admin',
                html: `Vui lòng liên hệ NHSV theo số <b>19001055</b> để biết thêm chi tiết.`,
                allowOutsideClick: false,
                icon: 'error',
                confirmButtonText: 'Đã hiểu',
              }).then((result) => {
                if (result.isConfirmed) {
                  history('/auth')
                }
              })
            })
          return 0
        } else {
          return prevCountdown - 1
        }
      })
    }, 1000)

    return timerId
  }

  if (loading) {
    return (
      <div className='d-flex h-100'>
        <div className='m-auto'>
          <div className='w-100 d-flex'>
            <div className='m-auto'>
              <div className='mx-5'>
                <img src={toAbsoluteUrl('/media/nhsv/eKYC-4-done.png')} alt='img' />
              </div>
              <span className='m-auto d-block spinner-border text-primary' role='status'></span>
            </div>
          </div>
          <span className='d-block text-muted fs-3 fw-semibold mt-5'>
            Hợp đồng đang được khởi tạo trong{' '}
            <span className='text-primary fw-bold'>{secondsRemaining}s</span>
          </span>
        </div>
      </div>
    )
  }

  if (loading2) {
    return (
      <div className='d-flex h-100'>
        <div className='m-auto'>
          <div className='w-100 d-flex'>
            <div className='m-auto'>
              <span className='m-auto d-block spinner-border text-primary' role='status'></span>
              <div className='text-muted fs-3 fw-semibold mt-5'>
                Hợp đồng đang được khởi tạo trong{' '}
                <span className='text-primary fw-bold'>{loading2Countdown}s</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }

  if (loading3) {
    return (
      <div className='d-flex h-100'>
        <div className='m-auto'>
          <div className='w-100 d-flex'>
            <div className='m-auto'>
              <span className='m-auto d-block spinner-border text-primary' role='status'></span>
              <div className='text-muted fs-3 fw-semibold mt-5'>
                Hợp đồng đang được khởi tạo trong{' '}
                <span className='text-primary fw-bold'>{loading3Countdown}s</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }

  return (
    <div
      className='d-flex flex-column flex-column-fluid bgi-position-y-bottom position-x-center bgi-no-repeat bgi-size-contain bgi-attachment-fixed'
      style={{
        backgroundColor: 'rgb(235 243 243)',
      }}
    >
      <div className='d-flex flex-center flex-column flex-column-fluid p-10 pb-lg-20'>
        <a href='#' className='mb-12'>
          <img
            alt='Logo'
            src={toAbsoluteUrl('/media/logos/nhsv-logo-horizontal-light.svg')}
            className='h-45px'
          />
        </a>

        <div className='w-100 card-containers'>
          <div className='text-center'>
            <h1 className='text-dark fw-bolder mb-3'>Ký hợp đồng</h1>
            {/* <div className='text-gray-500 fw-semibold fs-6'>Lịch sử hợp đồng</div> */}

            <div className='text-center mb-10 mt-10'>
              <iframe
                className='rounded h-800px w-100'
                src={listEkycRes?.data_list[0]?.iframeUrl}
              ></iframe>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
